export default __webpack_public_path__ + "static/media/image 15.2984575c.png";